import i18n from '@/i18n'

export const roundNumber = (number, decimals) => {
  return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const scientificNumber = (num, digits) => {
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

export const clone = object => {
  return JSON.parse(JSON.stringify(object))
}

export const reducer = items => {
  return items.reduce((accumulator, item) => {
    const key = Object.keys(item)
    accumulator[key] = item[key]
    return accumulator
  }, {})
}

export const numberFormat = ({
  number,
  style = 'decimal',
  currency = 'EUR',
  display = 'short',
  digit = 1,
  notation = 'compact',
}) => {
  return new Intl.NumberFormat(i18n.locale, {
    style,
    currency,
    notation,
    maximumFractionDigits: digit,
    compactDisplay: display,
  }).format(number)
}
